import { currentYear } from "../utils";
import React from "react";
import { useTranslation } from "react-i18next";
import { selectConfig } from "../features/config/ConfigSlice";
import { useAppSelector } from "../app/hooks";

function OAGCopyright() {
  const { t } = useTranslation();
  const { components } = useAppSelector(selectConfig);

  if (components.ShowOAGCopyright) {
    return (
      <p className="is-size-7 has-text-centered oag-disclaimer">{`© ${currentYear} ${t(
        "OAG_DISCLAIMER"
      )}`}</p>
    );
  } else {
    return null;
  }
}

export default OAGCopyright;
